import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-h-screen relative overflow-hidden" }
const _hoisted_2 = { class: "relative z-10 min-h-screen flex items-center justify-center p-4 sm:p-6 lg:p-8" }
const _hoisted_3 = { class: "w-full max-w-3xl" }
const _hoisted_4 = { class: "text-center mb-8" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 0,
  class: "mb-6 rounded-md bg-green-50 p-4"
}
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "ml-3" }
const _hoisted_9 = { class: "text-sm text-green-700" }
const _hoisted_10 = {
  key: 1,
  class: "mb-6 rounded-md bg-red-50 p-4"
}
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = { class: "ml-3" }
const _hoisted_13 = { class: "text-sm text-red-700" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "text-center" }

import { computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useForgotPassword } from '@/composables/auth/useForgotPassword'
import { getBrandBySlug } from '@/config/brands'


export default /*@__PURE__*/_defineComponent({
  __name: 'ForgotPasswordView',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const currentBrand = computed(() => {
  const brandSlug = route.params.brandSlug as string
  return getBrandBySlug(brandSlug)
})

const isFalken = computed(() => currentBrand.value?.name?.toLowerCase() === 'falken')

// eslint-disable-next-line @typescript-eslint/no-var-requires
const backgroundImage = require('@/assets/staticbg.png')

const { email, loading, error, success, handleForgotPassword } = useForgotPassword()

const goToLogin = () => {
  router.push(`/login/${currentBrand.value?.slug}`)
}

// Redirect if no brand slug
onMounted(() => {
  if (!currentBrand.value) {
    router.push('/brands')
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "absolute inset-0 bg-cover bg-center bg-no-repeat",
      style: _normalizeStyle({ backgroundImage: `url(${_unref(backgroundImage)})` })
    }, null, 4),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-70" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            (currentBrand.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: currentBrand.value.formLogo,
                  alt: currentBrand.value.name,
                  class: "mx-auto w-120 object-contain"
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("h2", {
              class: "text-5xl font-medium",
              style: _normalizeStyle({ color: currentBrand.value?.color })
            }, _toDisplayString(isFalken.value ? 'Road Hazard Ready' : 'TOTAL CONFIDENCE PLAN'), 5),
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "mt-6 mb-4 text-2xl text-white" }, " Reset Your Password ", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-lg text-white opacity-90" }, " Enter your email address and we'll send you a link to reset your password ", -1))
          ]),
          (_unref(success))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                    _createElementVNode("svg", {
                      class: "h-5 w-5 text-green-400",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 20 20",
                      fill: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "fill-rule": "evenodd",
                        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                        "clip-rule": "evenodd"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(success)), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(error))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                    _createElementVNode("svg", {
                      class: "h-5 w-5 text-red-400",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 20 20",
                      fill: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "fill-rule": "evenodd",
                        d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                        "clip-rule": "evenodd"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(error)), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_unref(handleForgotPassword) && _unref(handleForgotPassword)(...args)), ["prevent"])),
            class: "space-y-6"
          }, [
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                id: "email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
                type: "email",
                placeholder: "Email Address*",
                required: "",
                class: "w-full px-8 py-5 bg-transparent border-2 rounded-lg focus:outline-none placeholder-white placeholder:text-lg brand-input",
                style: _normalizeStyle({
                  borderColor: currentBrand.value?.color,
                  color: 'white',
                  '--focus-color': currentBrand.value?.color
                })
              }, null, 4), [
                [_vModelText, _unref(email)]
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "submit",
                disabled: _unref(loading),
                class: "w-full py-5 px-4 rounded-lg text-white text-xl font-medium transition-all duration-200 hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed",
                style: _normalizeStyle({ backgroundColor: currentBrand.value?.color })
              }, _toDisplayString(_unref(loading) ? 'Sending...' : 'Send Reset Link'), 13, _hoisted_14)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("a", {
                href: "#",
                onClick: _withModifiers(goToLogin, ["prevent"]),
                class: "text-lg font-medium hover:underline",
                style: _normalizeStyle({ color: currentBrand.value?.color })
              }, " Back to Sign In ", 4)
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}
}

})